import { gql } from 'react-apollo';

export const invalidateToken = gql`
  mutation invalidateToken($input: InvalidateUserTokenInput!) {
    invalidateToken(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/components/authorization/mutations/invalidateToken.js